export default "__VITE_ASSET__04c87137__"